module.exports = __webpack_public_path__ + "img/pro_one_11.e324a6c4.jpg";